import { render, staticRenderFns } from "./MediaListPage.vue?vue&type=template&id=137284ac&scoped=true&"
import script from "./MediaListPage.vue?vue&type=script&lang=js&"
export * from "./MediaListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137284ac",
  null
  
)

export default component.exports